import React from 'react';
import { isDataLoaded } from '../../types';
import { useStarfishDeviceDetails } from '../../data/DataProviders/StarfishGatewayDeviceDetailsProvider';
import { DeleteSFModal } from '../CommonDeleteModals/DeleteSFModal';

export const DeleteSFGatewayModal: React.FC<{
    open: boolean;
    onClose: Function;
    handleContinue: Function;
    name: string;
}> = (props) => {
    const { onClose, open, handleContinue, name } = props;
    const deviceDetails = useStarfishDeviceDetails();

    return (
        <DeleteSFModal
            open={open}
            onClose={onClose}
            handleContinue={handleContinue}
            data={
                isDataLoaded(deviceDetails)
                    ? deviceDetails?.value.childDevices === null
                        ? []
                        : deviceDetails?.value.childDevices
                    : []
            }
            name={name}
        />
    );
};
